"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Global error boundary caught:", error);
  }, [error]);

  return (
    <html>
      <body className="min-h-screen bg-[var(--zom-white)] text-[var(--zom-rich-black)]">
        <div className="relative flex min-h-screen items-center justify-center px-6 py-16 text-center">
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_70%_40%_at_50%_0%,rgba(var(--zom-accent-primary-rgb),0.09)_0%,transparent_60%),radial-gradient(ellipse_60%_40%_at_20%_20%,rgba(var(--zom-accent-secondary-rgb),0.05)_0%,transparent_45%)]" />
          <div className="relative z-10 max-w-2xl space-y-4">
            <p className="font-body text-xs font-medium text-[var(--zom-gunmetal)] uppercase">
              System Error
            </p>
            <p className="font-display text-3xl font-light text-[var(--zom-rich-black)] md:text-4xl">
              Something went wrong.
            </p>
            {error?.message ? (
              <p className="font-body text-sm text-[var(--zom-gunmetal)]">
                {error.message}
              </p>
            ) : null}
            <Button
              onClick={() => {
                if (reset && typeof reset === "function") {
                  reset();
                }
              }}
              className="font-body rounded-full px-6 py-2.5 text-sm font-medium shadow-[0_12px_30px_-22px_rgba(15,23,42,0.25)]"
            >
              Try again
            </Button>
          </div>
        </div>
      </body>
    </html>
  );
}
